module.exports = __webpack_public_path__ + "static/media/insightsmodel16.6571b573.svg";